import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  model: null,
};

const slice = createSlice({
  name: "model",
  initialState,
  reducers: {
    setModel: (state, { payload }) => {
      state.model = payload;
    },
  },
});

export const { setModel } = slice.actions;

export const model = slice.reducer;
